import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

interface PaymentRangeFieldProps {
    shop?: ShopDTO;
}

const PaymentRangeField: React.FC<PaymentRangeFieldProps> = ({ shop }) => {
    if (shop?.type === ShopType.PDD_FDS || shop?.type === ShopType.ALIBABA_SUPPLIER) return null;

    return (
        <Form.Item label={<span className="search-field-label">实付金额</span>}>
            <div style={{ display: "flex" }}>
                <Form.Item name="minPayment" className="inline-block" style={{ marginRight: 0 }}>
                    <Input style={{ width: 45 }} />
                </Form.Item>
                <span className="to-label">至</span>
                <Form.Item name="maxPayment" className="inline-block" style={{ marginRight: 0 }}>
                    <Input style={{ width: 45 }} />
                </Form.Item>
            </div>
        </Form.Item>
    );
};

export default React.memo(PaymentRangeField);
